import storage from 'proxy-storage';
import fetchJSON from '../../utils/fetch/fetchJSON';
import config from '../../../js/core/config';

/**
 * @public
 * Get Invalid Phones and store in `hc`
 *
 * @returns  {Array} array of invalid phones
 */
function getInvalidPhonesOnDemand() {
  return fetchJSON(config.invalidPhones, {
    method: 'GET',
  }).then((response) => {
    const hcStorage = storage.getItem('hc');
    storage.setItem(
      'hc',
      Object.assign(hcStorage, {
        invalidPhonesOnDemand: response,
      }),
    );
    return response;
  });
}

export default getInvalidPhonesOnDemand;
